export function formatPrice(price, currency) {
    const format = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: currency || "GBP",
    });

    return format.format(price / 100);
}
